export default function LRHero() {
  return (
    <section className="relative w-full h-[78vh] min-h-[600px] overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9fe3dbfba7d6cb0d61347c3abcb2928c.jpg"
          alt="Calm Living Room Inspiration"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#FAF7F0] via-black/10 to-black/25" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/15 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-end pb-16 px-8 md:px-20 max-w-screen-xl mx-auto w-full">
        <div className="max-w-2xl">
          <span
            className="inline-flex items-center gap-2 text-white/65 text-[10px] tracking-[0.4em] uppercase mb-6"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            <span className="w-6 h-px bg-white/40 inline-block" />
            Living Rooms
          </span>

          <h1
            className="text-white text-5xl md:text-6xl lg:text-7xl leading-[1.08] mb-6"
            style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
          >
            Calm Living Room<br />
            <em>Inspiration</em>
          </h1>

          <p
            className="text-white/70 text-sm md:text-base leading-relaxed mb-10 max-w-lg"
            style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
          >
            Explore soft beige living rooms, warm neutral palettes, natural textures, and
            peaceful layouts designed for slower living.
          </p>

          <a
            href="#inspiration-grid"
            className="inline-flex items-center gap-2.5 bg-white text-[#2C2825] px-9 py-3.5 rounded-full text-xs tracking-[0.18em] hover:bg-[#FAF7F0] transition-all duration-300 cursor-pointer whitespace-nowrap uppercase"
            style={{ fontFamily: "'Inter', sans-serif", fontWeight: 500 }}
          >
            Browse Living Room Ideas
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-arrow-down-line text-xs" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}
